
import { useState, useEffect,useRef } from 'react';

import { Simplebar } from '../Simplebar/Simplebar';
export const PantallaSimplebar = ({
                                      name,
                                      showCanvas,
                                      setShowCanvas,
                                      afterSave,
                                      entidad,
                                      cuentaIdSec,
                                      cuentaNombre,
                                      cuentaIdSecList,
                                  }) => {
    const ref = useRef(null);
    const refContacto = useRef(null);
    const childCuentaRef = useRef(null);
    const childContactoRef = useRef(null);

    const [showContacto, setShowContacto] = useState(false);
    const [showCuenta, setShowCuenta] = useState(false);

    useEffect(() => {
        if (showCanvas) {
            switch (name) {
                case "contacto":
                    setShowContacto(true);
                    break;
                case "cuenta":
                    setShowCuenta(true);
                    break;
                default:
                    break;
            }
        } else {
            setShowContacto(false);
            setShowCuenta(false);
        }
    }, [name, showCanvas, afterSave]);

    const handleCuentaClick = () => {
        childCuentaRef.current?.grabar();
    };

    const SimplebarCuentaContainer = (
        <Simplebar
            ref={ref}
            backdrop={true}
            placement={"end"}
            portal={false}
            visible={showCuenta}
            size="xxl"
            setShow={(e) => {
                setShowCanvas(e);
                setShowCuenta(e);
            }}
            useLoading={true}
            title={"Crear Cuenta"}
            btnLeft={{
                show: true,
                message: "Grabar",
                isComponent: true,
                size: "45px",
                height: "24px",
                with: "24px",
                iconName: "save",
                isCenter: true,
                func: handleCuentaClick,
            }}
            btnRight={{
                show: false,
                label: "Grabar",
                func: () => {},
            }}
        >
            <div>
                <h2>Cuenta Edit</h2>
            </div>
        </Simplebar>
    );
    
    return (
        <>
            {name === "cuenta" && <div>{SimplebarCuentaContainer}</div>}
        </>
    );
};
